import React from 'react';

import { BaseLabel, RowContainer, InputSmall, Label, Select } from '../../../../styles/styleUtils';

function Parcelas({ formData, onInputChange }) {
  return (
    <div>
      <RowContainer>
        <BaseLabel htmlFor="quantidadeParcelas">Quantidade de Parcelas</BaseLabel>
        <InputSmall
          type="number"
          id="quantidadeParcelas"
          name="quantidadeParcelas"
          value={formData.quantidadeParcelas}
          onChange={onInputChange}
          disabled={formData.visualiza}
        />
        <span />
        <span />
        <span />
        <span /><span />
        <span />
        <span />
        <span />
        {formData.quantidadeParcelas > 1 && <Label htmlFor="periodicidade">Periodicidade</Label>}
        {formData.quantidadeParcelas > 1 && (
          <Select
            id="periodicidade"
            name="periodicidade"
            value={formData.periodicidade}
            onChange={onInputChange}
            disabled={formData.visualiza}
          >
            <option value="">Selecione</option>
            <option value="quinzenal">Quinzenal</option>
            <option value="mensal">Mensal</option>
            <option value="bimestral">Bimestral</option>
          </Select>
        )}
      </RowContainer>
    </div>
  );
}

export default Parcelas;
